<template>
    <div class="hk-pagination flex flex-center">
        <el-pagination
            background
            :page-size="20"
            layout="prev, pager, next"
            :total="total"
            @current-change="handleCurrentChange"
        >
        </el-pagination>
    </div>
</template>

<script>
export default {
    props: {
        total: {
            type: Number,
            required: true
        }
    },
    data() {
        return {};
    },
    created() {},
    methods: {
        handleCurrentChange(val) {
            this.$emit('currentChange', val);
        }
    }
};
</script>
<style lang="scss" scoped>
.hk-pagination {
    margin-top: 50px;
}
</style>
